import { Page, Text, View, Document } from '@react-pdf/renderer';
import { pdfStyles } from './styles';
import PdfTableCell from './components/PdfTableCell';



// Теперь создам начальное состояние и селекторы для работы с данными:

const TableHeader = [{
    subject: 'Предмет',
    subgroup: 'Подгруппа',
    mainHW: 'Общее ДЗ',
    filesMainHW: 'Файлы общего ДЗ',
    indHW: 'Индивидуальное ДЗ',
    fio: "ФИО учащегося",
    text: "Текст индивидуального ДЗ",
    files: "Файлы индивидуального ДЗ"
}]

// Создам основной компонент с функциями для работы с таблицей:

const ExcelHomework = ({ homeworks }) => {

    const stylesCheckCell = (num) => num ? [pdfStyles.bold, pdfStyles.center,] : pdfStyles.ml3;

    return (
        <Document>

            <Page size="A4" orientation="landscape" style={pdfStyles.page}>
                <View style={pdfStyles.center}>
                    <Text style={pdfStyles.underline}>{"Министерство обороны Российской Федерации Федеральное государственное казенное общеобразовательное учреждение «Санкт-Петербургский кадетский корпус «Пансион воспитанниц Министерства обороны Российской Федерации»"}</Text>
                </View>

                <View style={[pdfStyles.center, pdfStyles.mb10, pdfStyles.mt10]}>
                    <Text style={pdfStyles.title}>{"ДОМАШНИЕ ЗАДАНИЯ"}</Text>
                </View>

                <View style={[pdfStyles.left, pdfStyles.mb20]}>
                    <Text>{'Класс'}</Text>
                </View>
                <View style={[pdfStyles.left, pdfStyles.mb20]}>
                    <Text>{'Дата'}</Text>
                </View>
                < View style={[pdfStyles.table]} >
                    {
                        // [headers, ...forTable].map((item, index) => (
                        TableHeader && TableHeader.map((item) => (
                            <>
                                <View style={pdfStyles.tableCol100}>

                                    <View style={[pdfStyles.tableRow, pdfStyles.bigHeight]}>
                                        <PdfTableCell
                                            text={item.semester ? `${item.name}, ${item.semester}` : item.subject}
                                            cellStyle={pdfStyles.tableCol10}
                                            hasNumber={item.number}
                                            stylesCheckCell={stylesCheckCell}
                                        />
                                        <PdfTableCell
                                            text={item.type !== null && item.subgroup}
                                            cellStyle={pdfStyles.tableCol10}
                                            hasNumber={item.number}
                                            stylesCheckCell={stylesCheckCell}
                                        />
                                        <PdfTableCell
                                            text={item.mainHW}
                                            cellStyle={[pdfStyles.tableCol10, pdfStyles.center]}
                                            hasNumber={item.number}
                                            stylesCheckCell={stylesCheckCell}
                                        />
                                        <PdfTableCell
                                            text={item.filesMainHW}
                                            cellStyle={[pdfStyles.tableCol10, pdfStyles.center]}
                                            hasNumber={item.number}
                                            stylesCheckCell={stylesCheckCell}
                                        />
                                        <View style={[pdfStyles.tableCol60, pdfStyles.center]}>
                                            <View style={[pdfStyles.tableCol, pdfStyles.tableCol120, pdfStyles.centerFlex]}>
                                                <Text style={stylesCheckCell(item.number)}>{item.indHW}</Text>
                                            </View>
                                            <View style={[pdfStyles.tableRow, pdfStyles.bigHeight]}>
                                                <PdfTableCell
                                                    text="ФИО учащегося"
                                                    cellStyle={[pdfStyles.centerFlex, pdfStyles.tableCol, pdfStyles.tableCol40]}
                                                    hasNumber={item.number}
                                                    stylesCheckCell={stylesCheckCell}
                                                    innerStyle={[]}
                                                />
                                                <PdfTableCell
                                                    text="Текст индивидуального ДЗ"
                                                    cellStyle={[pdfStyles.centerFlex, pdfStyles.tableCol, pdfStyles.tableCol40]}
                                                    hasNumber={item.number}
                                                    stylesCheckCell={stylesCheckCell}
                                                    innerStyle={[]}
                                                />
                                                <PdfTableCell
                                                    text="Файлы"
                                                    cellStyle={[pdfStyles.centerFlex, pdfStyles.tableCol, pdfStyles.tableCol40]}
                                                    hasNumber={item.number}
                                                    stylesCheckCell={stylesCheckCell}
                                                    innerStyle={[]}
                                                />
                                            </View>
                                        </View>
                                    </View>
                                </View>
                            </>
                        ))
                    }
                    {homeworks && homeworks.map((item) => (
                        <>
                            <View style={pdfStyles.tableCol100}>

                                <View style={[pdfStyles.tableRow, pdfStyles.bigHeight]}>
                                    <PdfTableCell
                                        text={item.lesson_name}
                                        cellStyle={pdfStyles.tableCol10}
                                        hasNumber={item.number}
                                        stylesCheckCell={stylesCheckCell}
                                    />
                                    <PdfTableCell
                                        text={item.subgroup !== null && item.subgroup}
                                        cellStyle={pdfStyles.tableCol10}
                                        hasNumber={item.number}
                                        stylesCheckCell={stylesCheckCell}
                                    />
                                    <PdfTableCell
                                        text={item.homework_text}
                                        cellStyle={[pdfStyles.tableCol10, pdfStyles.center]}
                                        hasNumber={item.number}
                                        stylesCheckCell={stylesCheckCell}
                                    />
                                    <PdfTableCell
                                        text={item.filesMainHW}
                                        cellStyle={[pdfStyles.tableCol10, pdfStyles.center]}
                                        hasNumber={item.number}
                                        stylesCheckCell={stylesCheckCell}
                                    />
                                    <PdfTableCell
                                        text={item.subgroup !== null && item.subgroup}
                                        cellStyle={[pdfStyles.centerFlex, pdfStyles.tableCol, pdfStyles.tableCol20]}
                                        hasNumber={item.number}
                                        stylesCheckCell={stylesCheckCell}
                                        innerStyle={[]}
                                    />
                                    <PdfTableCell
                                        text={item.subgroup !== null && item.subgroup}
                                        cellStyle={[pdfStyles.centerFlex, pdfStyles.tableCol, pdfStyles.tableCol20]}
                                        hasNumber={item.number}
                                        stylesCheckCell={stylesCheckCell}
                                        innerStyle={[]}
                                    />
                                    <PdfTableCell
                                        text={item.subgroup !== null && item.subgroup}
                                        cellStyle={[pdfStyles.centerFlex, pdfStyles.tableCol, pdfStyles.tableCol20]}
                                        hasNumber={item.number}
                                        stylesCheckCell={stylesCheckCell}
                                        innerStyle={[]}
                                    />
                                </View>
                            </View>
                        </>
                    ))
                    }
                </View >
                <View style={pdfStyles.mt50}>
                    <Text style={pdfStyles.ml10}>
                        {'Личная подпись обучающегося ________________'}
                    </Text>
                </View>

            </Page>
        </Document>

    )
}

export default ExcelHomework